export enum MyChartSendingDocumentsType {
  SENT = 'P',
  RECEIVED = 'I',
}

export enum MyChartSendingDocumentsOtherData {
  TAB_NAME = 'tabName',
}

export interface MyChartSendingDocumentsTypeData {
  documentType: string;
  value: string;
}
